const state = {
    salesLead: {
        unread: 0,
    },
    advertisment: {
        toBeSubmittedCount: 0,
        rejectedCount: 0,
    },
};

const mutations = {
    setUnread(state, { unread, type }) {
        if (state[type]) {
            state[type].unread = unread;
        }
    },
    decrementUnread(state, type) {
        if (state[type] && state[type].unread > 0) {
            state[type].unread--;
        }
    },
    setAdBadgeCounts(state, { toBeSubmittedCount = 0, rejectedCount = 0 }) {
        state.advertisment.toBeSubmittedCount = toBeSubmittedCount;
        state.advertisment.rejectedCount = rejectedCount;
    },
};
const actions = {
    setUnread(context, { unread, type }) {
        context.commit('setUnread', { unread, type });
        context.dispatch('menu/updateEBoothABBadgeFromUnread', type, { root: true });
    },
    decrementUnread(context, type) {
        context.commit('decrementUnread', type);
        context.dispatch('menu/updateEBoothABBadgeFromUnread', type, { root: true });
    },
    setAdBadgeCounts(context, payload) {
        context.commit('setAdBadgeCounts', payload);
        context.dispatch('menu/updateAdBadgeFromUnread', null, { root: true });
    },
};
const getters = {
    getUnread: (state) => (type) => state[type]?.unread || 0,
    getAdBadgeCounts: (state) => state.advertisment,
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};